import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useGetZones, useCreateZone } from '@ordr-as/ordr-service-types/epos';

export const useZoneApi = (locationId: number, createDefaultZoneIfEmpty = false) => {
  const queryClient = useQueryClient();

  const {
    queryKey,
    data,
    isPending: isZonesPending,
    ...zonesResult
  } = useGetZones(locationId, {
    query: {
      enabled: !!locationId,
      staleTime: 1000 * 60 * 60,
    },
  });

  const {
    mutate: createZone,
    isPending: isCreating,
    isSuccess: hasCreated,
  } = useCreateZone({
    mutation: {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey });
      },
    },
  });

  const shouldCreateZone = createDefaultZoneIfEmpty && data?.zones.length === 0 && !hasCreated && !isCreating;

  useEffect(() => {
    if (shouldCreateZone) {
      createZone({ locationId });
    }
  }, [shouldCreateZone, createZone, locationId]);

  const isPending = isZonesPending || isCreating;

  return { ...zonesResult, data, isPending };
};
